import { render, staticRenderFns } from "./ReplyHistoryForReceiveRequestTab.vue?vue&type=template&id=d8a44cce&scoped=true&lang=pug"
import script from "./ReplyHistoryForReceiveRequestTab.vue?vue&type=script&lang=ts"
export * from "./ReplyHistoryForReceiveRequestTab.vue?vue&type=script&lang=ts"
import style0 from "./ReplyHistoryForReceiveRequestTab.vue?vue&type=style&index=0&id=d8a44cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a44cce",
  null
  
)

export default component.exports